module.exports = __webpack_public_path__ + "img/depmap_svg_V187.9a885cf0.svg";